'use client'

import { createContext, useContext } from 'react'

type NavigationGuardState = {
  guardEnabled: boolean
  activateNavigationGuard: () => void
  disableNavigationGuard: (props?: { callback?: () => void }) => void
}

export const NavigationGuardContext =
  createContext<NavigationGuardState | null>(null)

export const useNavigationGuardEnabled = () => {
  const context = useContext(NavigationGuardContext)

  if (!context) {
    throw new Error(
      'useNavigationGuard must be used within a NavigationGuardProvider',
    )
  }

  return context
}
